// @ts-nocheck
import React, { useEffect, useState } from 'react';
import styles from '@features/voucher-new/styles/voucher-new.module.css';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { useAtomValue } from 'jotai';
import {
  resendVoucherOTP,
  verifyVoucherOTP,
  resetVoucherTimer,
} from '@features/voucher-subscription/model/voucher-subscribe-flow';
import { useHistory } from 'react-router-dom';
import { useQuery } from '@shared/hooks';
import Alert from '@shared/ui/alert/ui/Alert';
import { languageAtom, voucherAtom } from '@shared/store/slice-atoms';

export const VoucherPinFormNew = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { query } = useQuery();
  const isInternalDebugging = query.get('isInternalDebugging');

  const language = useAtomValue(languageAtom);
  const voucher = useAtomValue(voucherAtom);
  const reachedThankYou = voucher.reachedThankYou;
  const voucherRes = voucher.voucherRes;
  const btnLoading = voucher.btnLoading;
  const timerActive = voucher.timerActive;
  const timerCount = voucher.timerCount;

  const [pin, setPin] = useState('');
  const [timer, setTimer] = useState(60);

  const handlePinChange = (e) => {
    setPin(e.target.value);
  };

  const isFormValid = !!pin;

  const handleSubmit = (e) => {
    e.preventDefault();
    submitToServer(pin);
  };

  const submitToServer = (_pin) => {
    let inputFields = {
      otp: _pin,
      language: language.locale,
    };
    verifyVoucherOTP(inputFields, voucherRes, history, isInternalDebugging);
  };

  const handleResendPin = () => {
    if (timerCount <= 2) {
      let inputFields = { language: language.locale };
      resendVoucherOTP(inputFields, voucherRes, isInternalDebugging);
      setTimeout(() => setTimer((timer) => timer - 1), 1000);
    }
  };

  useEffect(() => {
    if (timer > 0 && timerActive) {
      setTimeout(() => setTimer((timer) => timer - 1), 1000);
    } else {
      setTimer(60);
      resetVoucherTimer();
    }
  }, [timer]);

  return (
    <div className={styles.voucherFormWrapper} style={{ gap: '27px' }}>
      <input value={pin} onChange={handlePinChange} className={styles.pinFormInput} />

      <button
        className={cn(
          styles.voucherPinFormSubmit,
          isFormValid ? styles.voucherFormSubmitValid : ''
        )}
        disabled={!isFormValid || btnLoading}
        onClick={handleSubmit}
      >
        {t('continue')}
      </button>

      <Alert />

      {timerCount <= 2 && timerActive ? (
        <p className={styles.resendCodeText}>{`${t('resend_code')} 00:${timer}`}</p>
      ) : (
        <p className={styles.getNewCodeText} onClick={handleResendPin}>
          {t('resend_code')}
        </p>
      )}
    </div>
  );
};
